/**
 * SingleWeekView Component
 *
 * View component for 7-day mode in the Sales Timeline.
 * Displays a single WeekChart with legend for one week of data.
 *
 * US-PE-006: Sales Timeline - Phase 3 Page Components
 */

import WeekChart from './WeekChart'
import ChartLegend from './ChartLegend'
import { CHART_CONFIG } from './chart-config'

/**
 * SingleWeekView - Single week chart view
 *
 * @param {Object} props
 * @param {Array} props.data - Daily data array for the week from useTimelineData
 * @param {Array} props.strains - Array of strain objects { id, name, color }
 * @param {boolean} [props.showAllStrains=true] - Show all strains stacked or single strain
 * @param {string|null} [props.selectedStrainId] - Selected strain ID for single strain view
 * @param {string} [props.weekLabel] - Optional week label (e.g., "6 - 12 Jan 2026")
 * @param {string} [props.className] - Additional CSS classes
 */
export default function SingleWeekView({
  data = [],
  strains = [],
  showAllStrains = true,
  selectedStrainId = null,
  weekLabel,
  className = ''
}) {
  // Filter strains that have data in this week
  const strainsWithData = strains.filter(strain => {
    return data.some(item =>
      item.supplyByStrain && item.supplyByStrain[strain.name] > 0
    )
  })

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Legend */}
      {showAllStrains && strainsWithData.length > 0 && (
        <div className="bg-white rounded-lg border border-slate-200 px-4 py-3">
          <ChartLegend
            strains={strainsWithData}
            showDemandLine={true}
          />
        </div>
      )}

      {/* Chart */}
      <div className="bg-white rounded-lg border border-slate-200 p-4">
        <WeekChart
          data={data}
          strains={strains}
          showAllStrains={showAllStrains}
          selectedStrainId={selectedStrainId}
          weekLabel={weekLabel}
          height={CHART_CONFIG.dimensions.height}
        />
      </div>
    </div>
  )
}
